import { isDefined } from "./defined";

// TODO maybe extends using prototypes to make Array.empty or Array.has available ... (same for other libs...)

/**
 * Type predicate returning `true` if the provided `value` is an `Array` / `[]` type.
 */
export function isArray<ValueT>(value: ValueT | ValueT[] | null | undefined): value is ValueT[];

/**
 * Type predicate returning `true` if the provided `value` is an `readonly` `Array` / `[]` type.
 */
export function isArray<ValueT>(value: ValueT | readonly ValueT[] | null | undefined): value is readonly ValueT[];

export function isArray<ValueT>(value: ValueT | ValueT[] | readonly ValueT[] | null | undefined): value is ValueT[] {
    return isDefined(value) && Array.isArray(value);
}

/**
 * Type predicate returning `true` if the provided `value` #isDefined and not #isArray.
 */
export function isNonArray<ValueT>(value: ValueT | ValueT[] | readonly ValueT[] | null | undefined): value is ValueT {
    return isDefined(value) && !isArray(value);
}

/**
 * Returning `true` if the provided `array` is not empty
 */
export const empty = <ValueT>(array: ValueT[] | readonly ValueT[]): boolean => array.length === 0;

/**
 * Type predicate checking whether the provided `array` contains the provided `element`.
 */
export const hasElement = <ValueT>(array: ValueT[], element: unknown): element is ValueT => isDefined(array.find((e) => e === element));
